<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-from">
          <div class="posi-item col3">
            <div class="posi-item-title">套餐名称</div>
            <div class="posi-item-input">
              <el-input
                v-model="fromData.package"
                placeholder="请输入套餐名称"
              ></el-input>
            </div>
          </div>
          <div class="posi-item col3">
            <div class="posi-item-title xin">成交金额</div>
            <div class="posi-item-input">
              <el-input
                v-model="fromData.dealmoney"
                placeholder="请输入成交金额"
              ></el-input>
            </div>
          </div>
          <div class="posi-item col3">
            <div class="posi-item-title xin">影楼佣金归属</div>
            <div class="posi-item-input">
              <el-select
                filterable
                v-model="fromData.yinglousaler_id"
                placeholder="请选择影楼佣金归属人"
              >
                <el-option
                  v-for="item in pinfoArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="posi-btn">
        <div @click="handleSubmit">{{ dataVal.btn1 || "保存金额" }}</div>
      </div>
    </div>
  </div>
</template>
        <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        id: "",
        dealmoney: "",
        package: "",
        yinglousaler_id: "",
      },
      flag: false,
      pinfoArr: [],
    };
  },
  mounted() {
    this.userGetpinfo();
  },
  methods: {
    //得到介绍人
    async userGetpinfo() {
      let res = await this.$api.userGetpinfo({
        type: 1,
      });
      if (res.code == 1) {
        this.pinfoArr = res.data;
      }
    },
    //提交
    async handleSubmit() {
      if (!this.flag) {
        this.flag = true;
        let res = await this.$api.userSetmoney({
          ...this.fromData,
        });
        if (res.code == 1) {
          this.flag = false;
          let obj = {
            submitFlag: true,
            flag: false,
          };
          this.$emit("transactionAmountCell", obj);
          this.$message.success("提交成功");
        } else {
          this.flag = false;
        }
      }
    },
    //关闭
    handleClose() {
      let obj = {
        submitFlag: false,
        flag: false,
      };
      this.$emit("transactionAmountCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.fromData.dealmoney = "";
        this.fromData.package = "";
        this.fromData.yinglousaler_id = newVal.item.yinglousaler_id||"";
        this.fromData.id = newVal.item.id;
        this.flag = false;
        if (newVal.disable) {
        } else {
        }
      },
      deep: true,
    },
  },
};
</script>
      <style>
.el-select-dropdown {
  z-index: 10000 !important;
}
</style>
        <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.pl1 {
  height: 40px;
  border-radius: 10px;
  background: #f2f2f7;
  line-height: 40px;
  font-size: 12px;
  padding-left: 51px;
}
.pl2 {
  height: 60px;
  border-radius: 10px;
  background: #f2f2f7;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  div:nth-child(2) {
    margin: 0 50px;
  }
}
.h201 {
  display: block;
  height: 381px;
  width: auto;
  margin: 0 auto;
}
.posi-center {
  width: 521px;
  height: 460px;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .scpz {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #aeaeb2;
    img {
      width: 35px;
      height: 35px;
      margin-right: 7px;
    }
  }
  .posi-over {
    font-size: 16px;
    color: #000000;
    padding: 15px 35px 0;
    height: 311px;
    overflow: auto;
    .posi-from {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .posi-item {
        width: 360px;
        margin-bottom: 15px;
        /deep/.upload-demo {
          width: 100%;
          .el-upload {
            width: 100%;
          }
          .el-upload-dragger {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f2f2f7;
          }
          .zp {
            height: 100%;
            width: auto;
          }
        }
        .posi-item-title {
          color: #606060;
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 11px;
          @include flex-center(flex-start, center);
          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 18px;
            border-radius: 2px;
            background-color: $y-color;
            margin-right: 7px;
          }
        }
        .xin::after {
            content: "*";
            display: block;
            font-size: 12px;
            color: #EE0A24;
        }
        /deep/.posi-item-input {
          width: 100%;

          .el-select {
            width: 100%;
          }
          input {
            width: 100%;
            height: 40px;
            background-color: #f5f6fa;
            //   color: #a6a6a6;
            color: #000;
            font-size: 12px;
            border: 1px solid #f5f6fa;
            outline: none;
            padding-left: 16px;
          }
          /deep/.el-input__inner {
            height: 40px;
            line-height: 40px;
            background-color: #f5f6fa;
            color: #000;
            font-size: 12px;
            border: 1px solid #f5f6fa;
          }
        }
        .jichu {
          display: flex;
          div {
            display: flex;
            align-items: center;
            font-size: 13px;
            span {
              color: #8e8e93;
            }
            &:first-child {
              margin-right: 66px;
            }
          }
        }
        .sex {
          width: 100%;
          margin: 25px 0 30px;
          background-color: #f2f2f7;
          height: 40px;
          @include flex-center(center, center);
          border-radius: 5px;
          .sex-item {
            @include flex-center(center, center);
            color: #000000;
            font-size: $f-size-14;
            cursor: pointer;
            margin-right: 4.828vw;
            .sex-yuan {
              width: 10px;
              height: 10px;
              border: 1px solid #aeaeb2;
              border-radius: 50%;
              margin-right: 6px;
            }
            .sex-active {
              background-color: $y-color;
              border: 1px solid $y-color;
            }
            &:last-child {
              margin-right: 0;
            }
            &:hover {
              color: $y-color;
            }
          }
        }
      }
      .col3 {
        width: 100%;
        margin-right: 0;
      }
      .col1 {
        width: calc((100% - 50px) / 3);
        margin-right: 25px;
      }
      .col2 {
        width: calc(((100% - 25px) / 3 * 2));
      }
      .mr0 {
        margin-right: 0;
      }
      .mt0 {
        margin-bottom: 0;
      }
    }
  }
  .posi-btn {
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>